import React, { useEffect } from 'react';
import { Icon, GridCell, Card, Table, EmptyState } from '@innovaccer/design-system';
import noResult from '../../../assets/images/noResult.png';
import api from '../../../api';
import { schema } from './getTableConfig';
import classes from './styles.module.css';
import NestedErrorRenderer from './nestedErrorRenderer';

const UpdateReport = (props) => {
  const [reportData, setReportData] = React.useState({
    loading: true,
    data: [],
    error: false
  });

  useEffect(() => {
    getVersionReport();
  }, []);

  const getVersionReport = () => {
    setReportData({
      loading: true,
      data: [],
      error: false
    });
    api
      .getStandardETLVersionUpdateReport()
      .then((res) => {
        setReportData({
          loading: false,
          data: res.document_List,
          error: false
        });
      })
      .catch(() => {
        setReportData({
          loading: false,
          data: [],
          error: true
        });
      });
  };

  return (
    <div className={`${classes.UpdateReportTable}`}>
      <Card className="h-100 overflow-hidden">
        <Table
          loading={reportData.loading}
          schema={schema}
          data={reportData.data}
          withHeader={true}
          headerOptions={{
            withSearch: true,
            dynamicColumn: false
          }}
          showMenu={false}
          onSearch={(currData, searchTerm) => {
            return currData.filter((d) => `Standard-etl-${d.version_id}`.toLowerCase().match(searchTerm.toLowerCase()));
          }}
          withCheckbox={false}
          withPagination={true}
          pageSize={50}
          onPageChange={(newPage) => console.log(`on-page-change:- ${newPage}`)}
          error={reportData.error}
          nestedRows={true}
          nestedRowRenderer={NestedErrorRenderer}
          errorTemplate={() => <EmptyState className="h-100" size="small" title="No data found" imageSrc={noResult} />}
        />
      </Card>
    </div>
  );
};

export default UpdateReport;
